const planConsentTemplate = `
<div   ng-if="vm.allowedToOverwrite == 'true'">

    <div class="row" >
        <h3 class="col-sm-10">{{ "summary.eDelivery.title" | translate }}</h3>


        <div class=" col-sm-2 btn-container">
            <a ng-click="openEConsentModal()" class="btn btn-primary"> 
                {{ "preference.button.change" | translate }}
            </a>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6 text-right">
            <strong> {{vm.planName}}</strong>
        </div> 

        <div class="col-sm-6" >  
            <div ng-show="vm.eDeliveryOption === 'NO_CONSENT_ANY_ELECTRONIC'">  {{ "preference.eDelivery.deliveryMethod.option1" |translate }}   {{vm.docTypes}}  {{ "preference.eDelivery.deliveryMethod.electronically" |translate }}   </div>
            <div ng-show="vm.eDeliveryOption === 'NO_CONSENT_ALL_MAIL'">  {{ "preference.eDelivery.deliveryMethod.option2" |translate }}   </div>
            <div ng-show="vm.eDeliveryOption === 'YES_CONSENT_ANY_ELECTRONIC'">  {{ "preference.eDelivery.deliveryMethod.option3" |translate }}   {{vm.docTypes}}  {{ "preference.eDelivery.deliveryMethod.electronically" |translate }}   </div>
            <div ng-show="vm.eDeliveryOption === 'YES_CONSENT_ALL_MAIL'">  {{ "preference.eDelivery.deliveryMethod.option4" |translate }}   </div>

        </div>
    </div>    

    <div class="row"  >

        <div class="col-sm-6 text-right" >
            <strong> {{ "preference.eDelivery.label.email" | translate }} </strong>
        </div>
        <div class="col-sm-6">

            {{vm.econsentemailAddress}}
        </div>

    </div>

</div>
 `;
 export default planConsentTemplate;